<div class="modal">
  <div #modalBody class="modal-content">
    <div class="modal-header">Conflits</div>
    <div class="modal-body">
      <div class="body-content">

        <div class="explication">{{ explication }}</div>
        
        <div class="conflicts-list">
          <div class="conflict-line" *ngFor="let c of conflictsDisplay">
            <div class="hours">{{ c.dateDebut | date:"dd/MM/yyyy" }} de {{ c.dateDebut | date:"H:mm" }} à {{ c.dateFin | date:"H:mm" }}</div>
            <div *ngFor="let r of c.ressourceName">- {{ r }}</div>
            <div class="description">{{ c.description || '' }}</div>
          </div>
        </div>

      </div>

      <div class="button-wrapper">
        <div class="question">Que voulez-vous faire ?</div>
        <div class="button-container">
          <frg-button [fullWidth]="true" [backgroundColor]="'var(--darkest-primary)'" (activated)="closeModal()">{{ cancelLabel }}</frg-button>
        </div>
        <div class="button-container">
          <frg-button [fullWidth]="true" (activated)="closeModal(true)">{{ validateLabel }}</frg-button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-background"></div>